import { ProductModel} from './product-model';
import { SeatAssignmentModel } from './seat-assignment-model';



export class ProductInstanceModel extends ProductModel {
    seatAssignments: Array<SeatAssignmentModel>;
}
